import React, { useCallback, useContext, useEffect, useMemo, useState, useRef } from "react";
import { MenuItem } from "@mui/material";

import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "../../../../componentsv2/Button";
import Paper from "../../../../componentsv2/Paper";
import { useSnackbar } from "notistack";

import DataPickerAtualizado from "../../../../components/DataPickerAtualizado";
import GridContainer from "../../../../componentsv2/GridContainer";
import GridItem from "../../../../componentsv2/GridItem";
import { Input } from "../../../../componentsv2/Input";
import SelectEnfermeiro from "../../Components/SelectEnfermeiro";
import TabelaProcedimentosAgendamento from "../../Components/TabelaProcedimentosAgendamento";
import SelectSituacao from "../../Components/SelectSituacao";
import SelectHorariosDisponiveis from "../../Components/SelectHorariosDisponiveis";
import PrescricoesAgendamento from "../../Components/PrescricoesAgendamento";
import AutoCompleteClientes from "../../../../componentsv2/AutoCompleteClientes";
import { api } from "../../../../services/Api";
import ModalProcedimento from "../ModalProcedimento";
import ObservacoesClinicas from "../../Components/ObservacoesClinicas";
import useArquivosPrescricao from "../../data/hooks/useArquivosPrescricao";
import useSelectClientes from "../../data/hooks/useSelectClientes";
import SelectEstado from "../../../../componentsv2/SelectEstado";
import SelectFormaPagamento from "../../Components/SelectFormaPagamento";
import { Context } from "../../../../Context/PermissoesContext";
import Header from "../../../../components/Header";
import Container from "../../../../componentsv2/Container";
import AutoCompleteMedicos from "../../../../componentsv2/AutoCompleteMedicos/Index";
import {
  OPCOES_LOCAL_ATENDIMENTO,
  OPCOES_MEDICACAO_ORIGEM,
  OPCOES_PAGAMENTO_STATUS,
} from "../../constants/agendamentoOptions";
import { abrirNoMaps, temEnderecoMinimo } from "../../utils/abrirNoMaps";
import {
  calcularSubtotal,
  formatarTotalExibicao,
  validarDesconto,
} from "../../utils/descontoAgendamento";
import Box from "../../../../componentsv2/Box";
import BotaoPdfAgendamento from "../../Components/BotaoPdfAgendamento";
import useObterPayloadPdfOrcamento from "../../data/hooks/useObterPayloadPdfOrcamento";
import Loading from "../../../../components/Loading";

const cpfSomenteDigitos = (cpf) => String(cpf ?? "").replace(/[^0-9]/g, "");

async function enviarContasAReceberSeNecessario(dados) {
  const { data } = await api.get(
    `/v2/contasaReceber/contasAReceberOrigemId/${dados.origemId}`
  );

  if (data?.id) {
    await api.put(`/v2/contasaReceber/editarContasAReceber/${data.id}`, {
      origem: dados.origem,
      origemId: dados.origemId,
      cpfCliente: dados.cpfCliente,
      codigoPedido: dados.codigoPedido,
      valor: dados.valor,
    });
    return;
  }

  await api.post(`/v2/contasaReceber/adicionaContasAReceber`, dados);
}

export default function FormularioAgendamento() {
  const { enqueueSnackbar } = useSnackbar();
  const [openModalForm, setOpenModalForm] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const history = useHistory();
  const { checarPermissao } = useContext(Context);
  const [procedimentoSelecionado, setProcedimentoSelecionado] = useState([]);
  // [{ procedimentoId, quantidade, precoExame }]

  const { cliente, setCliente, medico, setMedico } = useSelectClientes();
  const [enfermeiroId, setEnfermeiroId] = useState("");
  const [data, setData] = useState(new Date());
  const [hora, setHora] = useState("");
  const [situacao, setSituacao] = useState("");
  const [endereco, setEndereco] = useState("");
  const [numeroEndereco, setNumeroEndereco] = useState("");
  const [cep, setCep] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [complemento, setComplemento] = useState("");
  const [observacao, setObservacao] = useState("");
  const [estado, setEstado] = useState("");
  const [desconto, setDesconto] = useState(0);
  const [formaPagamento, setFormaPagamento] = useState("");
  const [localAtendimento, setLocalAtendimento] = useState("");
  const [medicacaoOrigem, setMedicacaoOrigem] = useState("");
  const [pagamentoStatus, setPagamentoStatus] = useState("");
  const {
    arquivosPrescricao,
    handleSelecionarArquivosPrescricao,
    handleRemoverArquivoPrescricao,
  } = useArquivosPrescricao();

  const [kilometragem, setKilometragem] = useState("");
  const [observacaoCliente, setObservacaoCliente] = useState("");

  const [atualizaTabelaProcedimentos, setAtualizaTabelaProcedimentos] =
    useState(false);

  const debounceTimerRef = useRef(null);
  const inputPrescricoesRef = useRef(null);

  const atualizarTabelaProcedimentos = () => {
    setAtualizaTabelaProcedimentos(!atualizaTabelaProcedimentos);
  };

  const buscarDadosCliente = useCallback(async () => {
    if (!cliente?.id) {
      return;
    }

    try {
      const {
        data: { data },
      } = await api.get(`v2/controleDna/cliente/${cliente.id}`);
      setBairro(data.bairro);
      setEndereco(data.endereco);
      setNumeroEndereco(data.enderecoNumero);
      setCep(data.cep);
      setCidade(data.cidade);
      setEstado(data.estado);
      setComplemento(data.complemento || "");
    } catch (error) {
      enqueueSnackbar(error.response.data.messages, {
        variant: "error",
      });
    }
  }, [cliente, enqueueSnackbar]);

  const pesquisarKilometragem = useCallback(
    async (enderecoPesquisa) => {
      try {
        const { data: enderecosEncontrados = [] } = await api.get(
          "/v2/agendaCare/pesquisaEndereco",
          {
            params: {
              endereco: enderecoPesquisa,
            },
          }
        );

        if (enderecosEncontrados.length === 0) {
          setKilometragem("");
          return;
        }

        const enderecoSelecionado = enderecosEncontrados[0]?.formatted_address;
        if (!enderecoSelecionado) {
          setKilometragem("");
          return;
        }

        const { data } = await api.post("/v2/agendaCare/distancia", {
          destino: [enderecoSelecionado],
        });

        if (!data?.[0]?.distance?.text) {
          setKilometragem("");
          return;
        }

        setKilometragem(data[0].distance.text);
      } catch (error) {
        setKilometragem("");
        enqueueSnackbar(error.response.data.messages, {
          variant: "error",
          autoHideDuration: 4000,
        });
      }
    },
    [enqueueSnackbar]
  );

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    if (salvando) return;

    let agendamentoId = null;

    try {
      const possuiValor = (value) => Boolean(String(value ?? "").trim());

      const camposObrigatorios = [
        { label: "Cliente", value: cliente?.id },
        { label: "Médico", value: medico?.id },
        { label: "Enfermeiro", value: enfermeiroId },
        { label: "Data", value: data },
        { label: "Situação", value: situacao },
        { label: "Horário", value: hora },
        { label: "Endereço", value: endereco },
        { label: "Número", value: numeroEndereco },
        { label: "CEP", value: cep },
        { label: "Bairro", value: bairro },
        { label: "Cidade", value: cidade },
        { label: "Local", value: localAtendimento },
        { label: "Medicação", value: medicacaoOrigem },
        { label: "Pagamento", value: pagamentoStatus },
      ];
      const campoFaltante = camposObrigatorios.find(
        ({ value }) => !possuiValor(value)
      );
      if (campoFaltante) {
        enqueueSnackbar(`Preencha o campo obrigatório: ${campoFaltante.label}.`, {
          variant: "warning",
        });
        return;
      }

      if (procedimentoSelecionado.length === 0) {
        enqueueSnackbar("Selecione ao menos um procedimento.", {
          variant: "warning",
        });
        return;
      }

      const subtotal = calcularSubtotal(procedimentoSelecionado);
      const validacaoDesconto = validarDesconto(desconto, subtotal);
      if (!validacaoDesconto.valido) {
        enqueueSnackbar(validacaoDesconto.mensagem, { variant: "warning" });
        return;
      }

      setSalvando(true);

      const procedimentos = procedimentoSelecionado.map(({ procedimentoId, quantidade }) => ({
        procedimentoId,
        quantidade,
      }));

      const dataNormalizada = data.hasOwnProperty("$d")
        ? data.$d.setHours(0, 0, 0)
        : data.setHours(0, 0, 0);

      const dados = {
        procedimentos,
        enfermeiroId,
        data: dataNormalizada,
        hora,
        complemento,
        observacoes: observacao,
        situacao,
        estado,
        cep,
        cidade,
        bairro,
        enderecoNumero: numeroEndereco,
        endereco,
        clienteId: cliente.id,
        desconto: validacaoDesconto.desconto,
        formaPagamento,
        localAtendimento,
        medicacaoOrigem,
        pagamentoStatus,
        distancia: kilometragem,
        medicoId: medico.id,
      };
      const respostaCriacao = await api.post("/v2/agendaCare/agendamento", dados);
      agendamentoId =
        respostaCriacao?.data?.data?.id ||
        respostaCriacao?.data?.id ||
        respostaCriacao?.data?.dataValues?.id;

      if (!agendamentoId) {
        throw new Error("ID do agendamento não retornado.");
      }

      if (situacao === "Realizado") {
        try {
          await enviarContasAReceberSeNecessario({
            origem: "AGENDA CARE",
            origemId: agendamentoId,
            cpfCliente: cpfSomenteDigitos(cliente?.cpf),
            nome: cliente?.nome || "",
            endereco,
            endereco_numero: numeroEndereco || "",
            complemento: complemento || "",
            bairro,
            cidade,
            estado,
            cep,
            celular: cliente?.celular || "",
            email: "",
            codigoPedido: "",
            valor: validacaoDesconto.totalLiquido.toFixed(2),
            tipo_pagamento: formaPagamento || "",
          });
        } catch (error) {
          enqueueSnackbar(
            error?.response?.data?.messages ||
              error?.response?.data?.mensagem ||
              "Agendamento criado, mas falhou Contas a Receber / Sankhya.",
            { variant: "warning" }
          );
        }
      }

      if (arquivosPrescricao.length > 0) {
        const formData = new FormData();
        arquivosPrescricao.forEach((arquivoPrescricao) => {
          formData.append("file", arquivoPrescricao);
        });

        await api.post(`/v2/agendaCare/agendamento/${agendamentoId}/prescricoes`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      history.push("/agendaCare");
      enqueueSnackbar("Agendamento feito com sucesso!", {
        variant: "success",
      });
    } catch (error) {
      const status = error?.response?.status;
      const erroDeUpload = [413, 415, 404].includes(status);

      if (erroDeUpload && agendamentoId) {
        enqueueSnackbar(error?.response?.data?.messages, { variant: "warning" });
        history.push("/agendaCare");
        return;
      }

      enqueueSnackbar(error?.response?.data?.messages, { variant: "error" });
    } finally {
      setSalvando(false);
    }
  };

  useEffect(() => {
    buscarDadosCliente();
  }, [buscarDadosCliente]);


  useEffect(() => {
    const enderecoPesquisa = [
      endereco?.trim(),
      numeroEndereco?.trim(),
      bairro?.trim(),
      cidade?.trim(),
      estado?.trim(),
    ]
      .filter(Boolean)
      .join(", ");

    if (enderecoPesquisa.length === 0) {
      setKilometragem("");
      return;
    }

    if (enderecoPesquisa.length < 3) {
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      pesquisarKilometragem(enderecoPesquisa);
    }, 500);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [endereco, numeroEndereco, bairro, cidade, estado, pesquisarKilometragem]);

  const subtotalProcedimentos = calcularSubtotal(procedimentoSelecionado);
  const validacaoDescontoAtual = validarDesconto(desconto, subtotalProcedimentos);
  const totalExames = formatarTotalExibicao(procedimentoSelecionado, desconto);

  const dadosPdf = useMemo(
    () => ({
      cliente,
      observacaoCliente,
      enfermeiroId,
      data,
      hora,
      situacao,
      endereco,
      numeroEndereco,
      cep,
      bairro,
      cidade,
      estado,
      complemento,
      observacao,
      desconto,
      formaPagamento,
      localAtendimento,
      pagamentoStatus,
      procedimentoSelecionado,
    }),
    [
      cliente,
      observacaoCliente,
      enfermeiroId,
      data,
      hora,
      situacao,
      endereco,
      numeroEndereco,
      cep,
      bairro,
      cidade,
      estado,
      complemento,
      observacao,
      desconto,
      formaPagamento,
      localAtendimento,
      pagamentoStatus,
      procedimentoSelecionado,
    ]
  );

  const obterPayloadPdf = useObterPayloadPdfOrcamento(dadosPdf);

  const handleDescontoChange = (event) => {
    const valor = event.target.value;
    if (valor === "") {
      setDesconto("");
      return;
    }
    if (!/^\d*(\.\d{0,2})?$/.test(valor)) {
      return;
    }
    setDesconto(valor);
  };

  return (
    <>
      <Header titulo={"Formulário de Agendamento"} />
      <Container maxWidth={false} sx={{ px: { xs: 3, md: 6, lg: 8 }, pt: 3, pb: 5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
          }}
        >
          <Button onClick={() => history.push({ pathname: "/agendaCare" })}>
            <ArrowBackIcon style={{ color: "#003399" }} />
          </Button>

          <BotaoPdfAgendamento
            label="Gerar orçamento (PDF)"
            tipoDocumento="orcamento"
            obterPayload={obterPayloadPdf}
          />
        </Box>
        <Paper
          sx={{
            px: { xs: 3, sm: 4, md: 5 },
            pt: { xs: 4, md: 5 },
            pb: 5,
            mt: 3,
            width: "100%",
            boxSizing: "border-box",
          }}
          elevation={2}
        >
          {openModalForm && (
            <ModalProcedimento
              open={openModalForm}
              onClose={() => {
                setOpenModalForm(false);
                atualizarTabelaProcedimentos();
              }}
            />
          )}
          <form
            onSubmit={handleSubmit}
            noValidate
            style={{ width: "100%" }}
          >
            <GridContainer
              spacing={2}
              sx={{ width: "100%", margin: 0, flexWrap: { xs: "wrap", md: "nowrap" } }}
              alignItems="flex-start"
            >
              <GridContainer item xs={12} md={6} spacing={2} sx={{ minWidth: 0 }}>
                <GridItem xs={12}>
                  <AutoCompleteClientes
                    value={cliente}
                    onChange={setCliente}
                    required
                  />
                </GridItem>
                <GridItem xs={12}>
                  <ObservacoesClinicas
                    clienteId={cliente?.id}
                    onDescricaoChange={setObservacaoCliente}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <AutoCompleteMedicos
                    onChange={setMedico}
                    value={medico}
                    required
                  />
                </GridItem>

                <GridItem xs={6}>
                  <DataPickerAtualizado
                    required
                    variant="standard"
                    labelName="Data"
                    xs={3}
                    data={data}
                    setData={setData}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <SelectSituacao
                    onChange={(e) => {
                      setSituacao(e.target.value);
                    }}
                    value={situacao}
                    todas={false}
                    required
                  />
                </GridItem>

                <GridItem xs={6}>
                  <SelectEnfermeiro
                    onChange={(e) => {
                      setEnfermeiroId(e.target.value);
                      setHora("");
                    }}
                    value={enfermeiroId}
                    required
                  />
                </GridItem>

                <GridItem xs={6}>
                  <SelectHorariosDisponiveis
                    onChange={(e) => {
                      setHora(e.target.value);
                    }}
                    data={data}
                    value={hora}
                    enfermeiroId={enfermeiroId}
                    required
                  />
                </GridItem>

                <GridItem xs={8}>
                  <Input
                    required
                    fullWidth
                    onChange={(e) => {
                      setEndereco(e.target.value);
                    }}
                    value={endereco}
                    label="Endereço"
                    type="text"
                    variant="standard"
                  />
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setNumeroEndereco(e.target.value);
                    }}
                    value={numeroEndereco}
                    required
                    fullWidth
                    label="Número"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>
                <GridItem xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    type="button"
                    size="small"
                    variant="text"
                    disabled={!temEnderecoMinimo({ endereco, cidade, cep })}
                    onClick={() =>
                      abrirNoMaps({
                        endereco,
                        numero: numeroEndereco,
                        bairro,
                        cidade,
                        estado,
                        cep,
                      })
                    }
                  >
                    Abrir no Maps
                  </Button>
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    required
                    fullWidth
                    onChange={(e) => {
                      setCep(e.target.value);
                    }}
                    value={cep}
                    label="CEP"
                    type="text"
                    variant="standard"
                  />
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setBairro(e.target.value);
                    }}
                    value={bairro}
                    required
                    fullWidth
                    label="Bairro"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    onChange={(e) => {
                      setCidade(e.target.value);
                    }}
                    value={cidade}
                    required
                    fullWidth
                    label="Cidade"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <SelectEstado
                    onChange={(e) => {
                      setEstado(e.target.value);
                    }}
                    value={estado}
                  />
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    onChange={(e) => {
                      setComplemento(e.target.value);
                    }}
                    value={complemento}
                    fullWidth
                    label="Complemento"
                    type="text"
                    variant="standard"
                  ></Input>
                </GridItem>

                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Local"
                    value={localAtendimento}
                    onChange={(e) => setLocalAtendimento(e.target.value)}
                    variant="standard"
                    SelectProps={{ MenuProps: { disableScrollLock: true } }}
                  >
                    {OPCOES_LOCAL_ATENDIMENTO.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Medicação"
                    value={medicacaoOrigem}
                    onChange={(e) => setMedicacaoOrigem(e.target.value)}
                    variant="standard"
                    SelectProps={{ MenuProps: { disableScrollLock: true } }}
                  >
                    {OPCOES_MEDICACAO_ORIGEM.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>
                <GridItem xs={4}>
                  <Input
                    select
                    required
                    fullWidth
                    label="Pagamento"
                    value={pagamentoStatus}
                    onChange={(e) => setPagamentoStatus(e.target.value)}
                    variant="standard"
                    SelectProps={{ MenuProps: { disableScrollLock: true } }}
                  >
                    {OPCOES_PAGAMENTO_STATUS.map((opcao) => (
                      <MenuItem key={opcao.value} value={opcao.value}>
                        {opcao.label}
                      </MenuItem>
                    ))}
                  </Input>
                </GridItem>

                <GridItem xs={12}>
                  <Input
                    onChange={e => {
                      setObservacao(e.target.value);
                    }}
                    value={observacao}
                    multiline
                    maxRows={5}
                    fullWidth
                    label="Observações"
                    type="text"
                    variant="standard"
                  />
                </GridItem>

              </GridContainer>

              <GridContainer item xs={12} md={6} spacing={2} sx={{ minWidth: 0 }}>
                <GridItem xs={12}>
                  <Box
                    sx={{
                      width: "100%",
                      minHeight: 480,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <TabelaProcedimentosAgendamento
                      atualizaTabela={atualizaTabelaProcedimentos}
                      setSelectedRows={setProcedimentoSelecionado}
                    />

                    <GridContainer spacing={2} alignItems="flex-start">
                    <GridItem xs={12} sm={6} lg={checarPermissao("AGC002") ? 3 : 6}>
                      <SelectFormaPagamento
                        onChange={(e) => {
                          setFormaPagamento(e.target.value);
                        }}
                        value={formaPagamento}
                        required
                      />
                    </GridItem>
                    {checarPermissao("AGC002") && (
                      <>
                        <GridItem xs={12} sm={6} lg={3}>
                          <Input
                            onChange={handleDescontoChange}
                            value={desconto}
                            fullWidth
                            label="Desconto R$"
                            type="number"
                            variant="standard"
                            inputProps={{ min: 0, step: 0.01 }}
                            error={!validacaoDescontoAtual.valido}
                            helperText={
                              !validacaoDescontoAtual.valido
                                ? validacaoDescontoAtual.mensagem
                                : ""
                            }
                          />
                        </GridItem>
                        <GridItem xs={12} sm={6} lg={3}>
                          <Input
                            value={totalExames}
                            fullWidth
                            label="Total"
                            type="text"
                            inputProps={{ readOnly: true }}
                            variant="standard"
                          />
                        </GridItem>
                        <GridItem xs={12} sm={6} lg={3}>
                          <Input
                            value={kilometragem}
                            fullWidth
                            label="Kilometragem"
                            type="text"
                            inputProps={{ readOnly: true }}
                            variant="standard"
                          />
                        </GridItem>
                      </>
                    )}
                    </GridContainer>

                    <GridContainer spacing={2}>
                  <GridItem xs={12}>
                    <h4 style={{ margin: "8px 0" }}>Prescrições</h4>
                    <div
                      style={{
                        border: "1px dashed #B0BEC5",
                        borderRadius: "10px",
                        minHeight: "110px",
                        padding: "14px 16px",
                        backgroundColor: "#FAFAFA",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="file"
                        ref={inputPrescricoesRef}
                        multiple
                        accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                        style={{ display: "none" }}
                        onChange={handleSelecionarArquivosPrescricao}
                      />
                      <Button
                        type="button"
                        variant="outlined"
                        style={{ color: "#0D47A1", fontSize: "16px", fontWeight: 600 }}
                        onClick={(event) => {
                          event.preventDefault();
                          inputPrescricoesRef.current?.click();
                        }}
                      >
                        Selecionar prescrições
                      </Button>
                      <span
                        style={{
                          marginTop: "14px",
                          fontSize: "14px",
                          color: "#424242",
                          fontWeight: 500,
                          textAlign: "center",
                        }}
                      >
                        PDF, JPG ou PNG - até 10MB por arquivo
                      </span>
                    </div>
                  </GridItem>
                  <GridItem xs={12}>
                    <PrescricoesAgendamento
                      prescricoes={arquivosPrescricao}
                      emptyText="Nenhum arquivo novo selecionado."
                      onRemove={handleRemoverArquivoPrescricao}
                    />
                  </GridItem>
                    </GridContainer>
                  </Box>
                </GridItem>
              </GridContainer>
            </GridContainer>
            <GridContainer
              sx={{ marginTop: "32px", width: "100%" }}
              justifyContent="flex-end"
              spacing={2}
            >
              <GridItem>
                <Button
                  onClick={() => history.push({ pathname: "/agendaCare" })}
                  color="gray"
                  variant="outlined"
                  disabled={salvando}
                >
                  Cancelar
                </Button>
              </GridItem>
              <GridItem>
                <Button
                  id="agendarButton"
                  type="button"
                  color="blue"
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={salvando}
                >
                  {salvando ? "Aguarde..." : "Agendar"}
                </Button>
              </GridItem>
            </GridContainer>
          </form>
        </Paper>
      </Container>
      {salvando && <Loading />}
    </>
  );
}
